import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ReactionsModule"
const debug = false

export class ReactionsModule extends ModuleProto {

    // public reactions         : number[]
    public disabledReactions : any
    public favoriteReactions : any

    constructor(moduleConfig:JSONObject) {
        super(ModuleType.REACTIONS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=",moduleConfig)

        this.name                    = "Reactions"
        this.description             = "Enhance your team communication by allowing users to express reactions with emojis on messages. Foster a more interactive and engaging collaboration experience effortlessly."
        this.svgIcon                 = "isvg-reactions"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = "Productivity & Collaboration"
        this.settingsUrl             = "settings/reactions"
        this.parentSection           = SettingsParentSection.PRODUCTIVITY


        this.disabledReactions          = _.get(moduleConfig, 'disabledReactions', [])
        this.favoriteReactions          = _.get(moduleConfig, 'favoriteReactions', [20,23,50,53,205,233])

        debug && console.log(debug, this.disabledReactions)
        debug && console.log(debug, this.favoriteReactions)
    }

    changeDisabled(config: number[]){
        this.disabledReactions = config
        this.saveSettings()
    }

    changeFavorite(config: number[]){
        this.favoriteReactions = config
        this.saveSettings()
    }

    resetReactions(){
        this.disabledReactions = []
        this.favoriteReactions = [20,23,50,53,205,233]
        this.saveSettings()
    }

    toJson(): JSONObject {
        const result = super.toJson();

        result.disabledReactions = this.disabledReactions
        result.favoriteReactions = this.favoriteReactions

        return result
    }
}